import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/33769276021?text=Bonjour%2C%20je%20souhaite%20des%20informations%20sur%20vos%20brunchs"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Nous contacter sur WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-espresso px-5 py-3.5 text-sm font-semibold text-cream shadow-xl transition-[background-color,transform] duration-300 hover:scale-105 hover:bg-terracotta"
    >
      <MessageCircle size={18} strokeWidth={1.5} />
      <span className="hidden sm:inline">WhatsApp</span>
    </a>
  );
}
